import { MijnRoute } from '../../mijn-navigatie.model';

export const PERSONAL_LOAN_OVERVIEW: MijnRoute = {
    path: 'persoonlijke-lening',
    navigationEvent: 'toPersoonlijkeLening',
    regex: /^\/persoonlijke-lening$/,
    webcomponent: 'mijn-persoonlijke-lening-webcomponent'
};
